export interface DocumentFileSource {
	File?: { Size?: number | null } | null;
	IsFrozen?: boolean | null;
	FrozenAt?: Date | string | null;
}

export function hasDocumentContent(document: DocumentFileSource | null | undefined): boolean {
	return (document?.File?.Size ?? 0) > 0;
}

export function isDocumentFrozen(document: DocumentFileSource | null | undefined): boolean {
	return hasDocumentContent(document) && (document!.IsFrozen === true || !!document!.FrozenAt);
}
